(function (angular) {
    angular.module('app.activation').service('ActivationService', ['$http', 'config', function activationService($http, config) {
        var service = {
            isExistingUserActive: isExistingUserActive,
            getUserIdByEmail: getUserIdByEmail,
            activateExistingUserAccount: activateExistingUserAccount,
            checkActivationStatus: checkActivationStatus
        }

        return service;

        function isExistingUserActive(user) {
            var url = environment.treatmentApiUrl + "purchase/check-msdp-activation";
            return $http.post(url, user);
        };

        function getUserIdByEmail(email) {
            var url = environment.treatmentApiUrl + "purchase/get-user-id?email=" + email;
            return $http.get(url, email);
        };

        function activateExistingUserAccount(user) {
            var url = environment.treatmentApiUrl + "purchase/activate-msdp-user";
            return $http.post(url, user);
        };

        function checkActivationStatus(userId) {
            var url = environment.treatmentApiUrl + "purchase/check-activation-no-external";
            return $http.post(url, userId);
        };
    }]);
})(angular);